/* global ol */
import ExtremeMapLandmarkLayerManager from '@/lib/ExtremeMapLandmarkLayerManager'
// import * as EVT from '@/consts/eventNames'
import Stream from '@/lib/Stream'

export default class ExtremeMapKilopostLayerManager extends ExtremeMapLandmarkLayerManager {
  constructor() {
    super()
    this.setStream(new Stream({ name: 'kilopostLayerDefault', debug: false }))
  }

  getKilopostColorMap_() {
    const fill = {
      white: 'rgba(255, 255, 255, 0.8)',
    }
    const stroke = {
      white: 'rgba(100, 100, 100, 0.8)',
    }
    return {
      point: {
        fill: Object.assign({}, fill),
        stroke: Object.assign({}, stroke),
      }
    }
  }

  getDefaultKilopostColor_(kp) {
    return 'white'
  }

  getNewKilopostPointStyle_({ color, text }) {
    const colorMap = this.getKilopostColorMap_()
    const fillColor = colorMap.point.fill[color]
    const strokeColor = colorMap.point.stroke[color]
    const ret = new ol.style.Style({
      // rect
      image: new ol.style.RegularShape({
        fill: new ol.style.Fill({
          color: fillColor,
        }),
        stroke: new ol.style.Stroke({
          color: strokeColor,
          width: 1
        }),
        points: 4,
        radius: 3,
        angle: Math.PI / 4,
      })
    })
    if (text) {
      ret.setText(new ol.style.Text({
        text: text,
        font: '8px sans-serif',
        fill: new ol.style.Fill({
          color: 'black'
        }),
        stroke: new ol.style.Stroke({
          color: 'rgba(255, 255, 255, 0.8)',
          width: 2,
        }),
        offsetX: 0,
        offsetY: 12,
      }))
    }
    return ret
  }

  getNewKilopostPointFeature_(point, info) {
    const feat = new ol.Feature({
      geometry: new ol.geom.Point(point)
    })
    feat.setId(info.id)
    feat.set('defaultColor', info.defaultColor)
    const style = this.getNewKilopostPointStyle_({
      color: info.defaultColor,
      text: info.text,
    })
    style.setZIndex(info.zIndex++)
    feat.setStyle(style)
    return feat
  }

  getKilopostFeaturesByKilopostId_(kpId) {
    const src = this.layer.getSource()
    const p1 = src.getFeatureById(kpId)
    return { p1 }
  }

  createKilopostLayer_(srcArr) {
    const info = {
      id: '',
      zIndex: 0,
      defaultColor: 'white',
    }
    const coords = []
    const feats = []
    for (const kp of srcArr) {
      info.defaultColor = this.getDefaultKilopostColor_(kp)
      const p1 = this.coordFromLonLat(kp.point.coordinates)
      coords.push(p1)
      info.id = kp.id
      let txt = ''
      if (kp.kp !== null) {
        const arr = [kp.kp_prefix, '(' + kp.direction + ')']
        if (kp.bikou1) { arr.push(kp.bikou1) }
        arr.push(kp.kp)
        txt = arr.join(' ')
      }
      info.text = txt
      feats.push(this.getNewKilopostPointFeature_(p1, info))
    }

    const layer = new ol.layer.Vector({
      source: new ol.source.Vector({ features: feats }),
    })
    layer.name = 'kilopost'
    layer.setZIndex = 100
    const extent = ol.extent.boundingExtent(coords)

    this.layer = layer
    this.layerInfo.extent = extent
  }

  prepareLayer(srcArr) {
    this.createKilopostLayer_(srcArr)
    return this.getLayer()
  }
}
